import { useEffect, useState } from 'react'
import { DatePicker } from 'antd'
import { getRepeatCount } from '../helpers'
import withRepeater from './withRepeater'

SequencedFormDateTimeInput = ({
  form,
  formItem,
  config = {},
  loading,
  queries,
  label,
  props... }) ->

  <DatePicker
    { props... }
    allowClear
    format={config?.format or 'DD-MM-YYYY HH:mm'}
    showTime={config?.showTime or true}
    picker={config?.picker or 'date'}
    placeholder={_.startCase(formItem)}
  />

export default withRepeater(SequencedFormDateTimeInput, { selector: (value) -> value })
